"use client";

import { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { CertificationBadge } from "./certification_badge";
import { DocumentModal } from "./document_modal";
import { Certification } from "@/types/schema";
import { brandQualityMockData } from "@/data/brand_quality_mock_data";

export function CertificationsSection() {
  const { certifications } = brandQualityMockData;
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCert, setSelectedCert] = useState<Certification | null>(null);

  const handleLinkClick = (cert: Certification) => {
    if (cert.documentImage === '') return;
    setSelectedCert(cert);
    setModalOpen(true);
  };

  return (
    <Stack spacing={12} alignItems="center">
      <Stack spacing={2} alignItems="center">
        <Typography
          sx={{
            background: "linear-gradient(90deg, rgba(205,120,88,1) 0%, rgba(255,217,105,1) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontFamily: "'Noto Sans Thai', sans-serif",
            fontSize: { xs: 24, md: 32 },
            fontWeight: 600,
            lineHeight: { xs: "32px", md: "38px" },
            textAlign: "center",
          }}
        >
          เอกสารรับรองมาตรฐาน
        </Typography>

        <Typography
          sx={{
            background: "linear-gradient(90deg, rgba(205,120,88,1) 0%, rgba(255,217,105,1) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontFamily: "'Noto Sans Thai', sans-serif",
            fontSize: 20,
            fontWeight: 600,
            lineHeight: "26px",
            textAlign: "center",
            display: { xs: "block", md: "none" },
          }}
        >
          Certificated ของเรา
        </Typography>
      </Stack>

      <Stack
        direction={{ xs: "column", md: "row" }}
        flexWrap="wrap"
        spacing={0}
        alignItems="stretch"
        justifyContent="center"
      >
        {certifications.badges.map((cert, index) => (
          <Box
            key={index}
            sx={{
              flex: { xs: "0 0 100%", md: "0 0 33.33%" },
              mb: { xs: 15, md: 15 },
            }}
          >
            <CertificationBadge
              image={cert.image}
              title={cert.title}
              onClick={() => handleLinkClick(cert)}
            />
          </Box>
        ))}
      </Stack>

      {selectedCert && (
        <DocumentModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          imageUrl={selectedCert.documentImage}
          title={selectedCert.title}
        />
      )}
    </Stack>
  );
}